import { LanguageCodes } from './loadi18n'
import { messages as messagesEn } from './en/messages'
import { messages as messagesDe } from './de-DE/messages'
import { messages as messagesAt } from './de-AT/messages'
import { messages as messagesIt } from './it-IT/messages'
import { messages as messagesFr } from './fr-BE/messages'
import { messages as messagesNl } from './nl-BE/messages'

const CATALOGS = {
  [LanguageCodes.EN]: messagesEn,
  [LanguageCodes.DE_DE]: messagesDe,
  [LanguageCodes.DE_AT]: messagesAt,
  [LanguageCodes.IT_IT]: messagesIt,
  [LanguageCodes.FR_BE]: messagesFr,
  [LanguageCodes.NL_BE]: messagesNl,
}

const getLanguage = () => {
  const documentLanguage = document?.documentElement?.lang

  return documentLanguage in CATALOGS ? documentLanguage : LanguageCodes.DE_DE
}

export default getLanguage
